import ToastAdapter from './ToastAdapter';

export default ToastAdapter;
